import apiRequest from './apiRequest';

export type AdminUserManagementAction =
  | {
      action: 'createOrganization';
      organizationName: string;
      creatorUserID: string;
    }
  | {
      action: 'addUserToOrganization';
      organizationID: string;
      targetUserIDOrEmail: string;
      planType: 'free' | 'pro' | 'unlimited';
      accessLevel: 'EDIT' | 'VIEW';
    }
  | {
      action: 'removeUserFromOrganization';
      organizationID: string;
      targetUserIDOrEmail: string;
    }
  | {
      action: 'modifyOrganizationSeatCapacity';
      organizationID: string;
      planType: 'pro' | 'unlimited' | 'team';
      seatCapacityDelta: number;
    }
  | {
      action: 'createServiceAccount';
      organizationID: string;
      serviceName: string;
    }
  | {
      action: 'updateServiceAccount';
      serviceID: string;
      accountBalanceDeltaUSD?: number;
      invalidAfter?: string;
    };

export type AdminUserManagementActionResponse =
  | { organization: Record<string, unknown> }
  | { apiKey: string; serviceID: string }
  | {
      serviceAccount: {
        serviceID: string;
        accountBalanceUSD: number;
        invalidAfter: string;
      };
    };

export default async function postAdminUserManagementActions(
  payload: AdminUserManagementAction,
) {
  return apiRequest<AdminUserManagementActionResponse>(
    'user',
    '/admin/userManagement/actions',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  );
}
